import { ITextField } from "@fluentui/react";

export function focusTextField(instance: ITextField | null) {
  if (instance) {
    instance.focus();
  }
}
